import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function Hero() {
  return <section className="bg-cream py-12 md:py-20 lg:py-24" data-id="element-92">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-93">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-94">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-95">
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl xl:text-7xl text-charcoal leading-tight mb-6" data-id="element-96">
              Cómo Recuperar Tu Cintura, Tu Energía y Tu Confianza en 21 Días
              Sin Contar Una Sola Caloría
            </h1>
            <p className="text-lg md:text-xl text-charcoal/70 mb-8 italic" data-id="element-97">
              — Incluso si sientes que tu metabolismo se "rompió" al cumplir los
              40 y nada de lo que antes funcionaba está dando resultados hoy.
            </p>
            <p className="text-base md:text-lg text-charcoal/80 mb-10 leading-relaxed" data-id="element-98">
              Deja de castigar a tu cuerpo con dietas de hambre y entrenamientos
              agotadores. Descubre el sistema de Sincronización Hormonal
              diseñado específicamente para la biología femenina en la etapa de
              la menopausia.
            </p>
            <motion.a href="#final-cta" onClick={() => trackAddToCart()} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full lg:w-auto bg-forest text-warm-white px-8 py-5 rounded-md text-base md:text-lg font-semibold flex items-center justify-center gap-3 shadow-lg hover:shadow-xl transition-shadow" data-id="element-99">
              SÍ, QUIERO RECUPERAR MI CUERPO Y MI ENERGÍA — ACCESO INMEDIATO
              <ArrowRightIcon className="w-5 h-5" data-id="element-100" />
            </motion.a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-101">
            <div className="rounded-lg overflow-hidden shadow-2xl" data-id="element-102">
              <img src="https://cdn.magicpatterns.com/uploads/gBVwDHYXe7jwrmnGMdd5E8/La_mayoria_llega_sin_esto…_(3).png" alt="Código Hormonal 40+ - Mujer elegante" className="w-full h-auto" data-id="element-103" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}